import { useAuthStore } from "@/stores/auth";


export default (to, from, next) => {
  const authStore = useAuthStore(); // Access the auth store

  // Re-sync JWT payload from cookie if needed
  authStore.setJwtPayloadData();

  // Determine if user has a fully authenticated session
  const isFullyAuthenticated = authStore.isUserAuthenticated && !authStore.isTokenExpired;

  // Check if token is expired
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };
  const hasTokenCookie = !!getCookie("authToken");
  const hasToken =
    !!authStore.tokenExpiry ||
    !!authStore.jwtPayload ||
    !!authStore.user?.access_token ||
    hasTokenCookie;
  const isExpired = hasToken && authStore.isTokenExpired;

  if (isExpired) {
    authStore.logout(false);
    return next({
      path: "/login",
      query: {
        logout: "true",
        expired: "true",
        ...(to.fullPath && to.fullPath !== "/" && to.fullPath !== "/login" ? { redirect_url: to.fullPath } : {}),
      },
    });
  }

  // If the user is completely unauthenticated (not fully logged in, and not in the pre-auth stage)
  if (!isFullyAuthenticated && !authStore.preAuthToken) {
    authStore.logout(false);
    if (hasToken) {
      return next({
        path: "/login",
        query: {
          logout: "true",
          expired: "true",
          ...(to.fullPath && to.fullPath !== "/" && to.fullPath !== "/login" ? { redirect_url: to.fullPath } : {}),
        },
      });
    }
    return next("/login");
  }

  // If the user is in the pre-auth stage (credentials accepted, but FIDO or 2FA challenge is pending)
  if (!isFullyAuthenticated && authStore.preAuthToken) {
    // Only allow navigating to /two-factor (since they can switch from FIDO to TOTP)
    if (to.path !== "/two-factor") {
      return next("/login");
    }
  }

  if (to.path == "/organisations") {
    next("/validate")
  }


  return next();

  // // Get the current time in ISO format
  // let currentTime = new Date().toISOString();

  // // Get the token expiry time from the store
  // let tokenExpiry = authStore.tokenExpiry;

  // // Adjust the time if the server is running locally
  // if (serverHost.includes("localhost") || serverHost.includes("127.0.0.1")) {
  //   currentTime = new Date(
  //     new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000
  //   ).toISOString();
  //   tokenExpiry = new Date(authStore.tokenExpiry).toISOString();
  // }

  // // Check if the token is expired
  // if (moment(currentTime).isSameOrAfter(tokenExpiry)) {
  //   authStore.setIsTokenExpired();
  // }

  // // Check if authentication is required and if the user is authenticated or the token is expired
  // if (to.meta.requiresAuth && (!isAuthenticated || isTokenExpired)) {
  //   console.log(to.path);

  //   // Set the redirect link to the current path if it's not the root path
  //   if (to.path !== "/" && to.path !== "" && to.path != null) {
  //     authStore.setRedirectLink(to.path);
  //   }

  //   // Log out the user
  //   authStore.logout();
  //   return next();
  // }

  // Proceed to the next middleware
};
